import {MARKER_END2} from './MarkerEndTypes2'

export const changeMarkerEnd2 = markerEnd2 => {
    return {
        type: MARKER_END2,
        load: markerEnd2
    }
}

export const selectNewMarkerEnd2 = (markerEnd2) => {

    return (dispatch) => {
        
        dispatch(changeMarkerEnd2(markerEnd2))
    }

}